import { memo, useCallback } from 'react';
import { useIntakeFormShallowStore } from '@frontend/api-intake-form';
import { Icon } from '@frontend/icons';
import { HOTSPOT_TARGET, OnboardingHotspot } from '@frontend/product-onboarding';
import { useNavSize } from '@frontend/responsiveness';
import { BillingRebrandPromo } from '@frontend/sales-dev';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { NakedButton } from '@frontend/design-system';
import { iconButtonStyles } from '../../styles/styles';
import { TopBarFocusIds } from '../../utils/focus-registry';

type SettingsButtonProps = {
  isSelected: boolean;
  isMobile: boolean;
  onClick: () => void;
};

export const SettingsButton = memo(({ isSelected, isMobile, onClick }: SettingsButtonProps) => (
  <NakedButton
    css={iconButtonStyles({ isSelected, isMobile })}
    onClick={onClick}
    id={TopBarFocusIds.settings}
    trackingId='top-bar-button-settings-2.0'
  >
    <Icon name='settings' />
  </NakedButton>
));
SettingsButton.displayName = 'SettingsButton';

export const SettingsButtonWrapper = () => {
  const { isShowIntakeForm } = useIntakeFormShallowStore('isShowIntakeForm');
  const { navigate: settingsNavigate, isOpen: settingsIsOpen } = useSettingsNavigate();
  const navSize = useNavSize();
  const isMobile = navSize.isLte('mobile');

  const handleSettingsNavigation = useCallback(() => {
    settingsNavigate({ to: '/organization' });
  }, [settingsNavigate]);

  if (isShowIntakeForm) return null;

  return (
    <li style={{ position: 'relative' }}>
      <OnboardingHotspot target={HOTSPOT_TARGET.TOP_BAR_SETTINGS_ICON} offset={{ top: 18, right: 12 }}>
        <SettingsButton isSelected={settingsIsOpen} isMobile={isMobile} onClick={handleSettingsNavigation} />
      </OnboardingHotspot>
      <BillingRebrandPromo
        source='top-bar-settings'
        containerStyles={{ position: 'absolute', top: '100%', right: -10 }}
      />
    </li>
  );
};
